var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoSmartico = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 0C9.85 0 0 9.85 0 22C0 34.15 9.85 44 22 44C34.15 44 44 34.15 44 22C44 9.85 34.15 0 22 0ZM36.72 21.37C34.94 25.15 29.055 28.87 28.44 29.035C28.44 29.035 31.83 28.935 32.385 29.68C32.385 29.68 28.165 29.815 25.885 31.59C23.605 33.37 19.72 33.31 19.275 32.81C19.275 32.81 23.495 31.59 23.94 30.42C23.94 30.42 18.22 30.81 13.495 25.085C8.78 19.37 5.165 15.37 2.055 14.705C2.055 14.705 10.5 12.985 15.445 19.595C20.39 26.205 23.055 29.54 26.61 28.595C30.165 27.65 32.055 21.48 33 19.87C33.945 18.26 35.665 14.5 41.945 14.5C41.945 14.5 38.5 17.595 36.72 21.37Z",
    fill: "#F86152"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoSmartico);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_smartico.2f10e87563ad2e2376518e63922b25cc.svg";